var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"skuTable",attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.tableHeight,"size":"small","row-id":"amzSkuCode","seq-config":{ startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize },"radio-config":!_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            strict: false,
            reserve: _vm.reserve,
          }
        : {},"checkbox-config":_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            reserve: _vm.reserve,
          }
        : {}},on:{"radio-change":_vm.radioChange,"checkbox-change":_vm.checkboxChange,"checkbox-all":_vm.checkboxChange},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"hxSkuSalesChannel",fn:function(ref){
        var row = ref.row;
return [(row.v_hxSkuSalesChannel)?_c('el-tag',{attrs:{"size":"mini","type":row.hxSkuSalesChannel === 'H'
            ? 'success'
            : row.hxSkuSalesChannel === 'V'
            ? 'warning'
            : ''}},[_vm._v(" "+_vm._s(row.v_hxSkuSalesChannel)+" ")]):_vm._e()]}},{key:"status",fn:function(ref){
            var row = ref.row;
return [_c('div',[_c('el-tag',{attrs:{"size":"mini","type":row.hxPreOrderStatus === 'D' || row.hxPreOrderStatus === 'R'
              ? 'danger'
              : row.hxPreOrderStatus === 'Y'
              ? 'success'
              : row.hxPreOrderStatus === 'S'
              ? 'warning'
              : ''}},[_vm._v(" "+_vm._s(row.v_hxPreOrderStatus)+" ")])],1)]}},{key:"createInfo",fn:function(ref){
              var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.createByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.createDate))])]}},{key:"modifyInfo",fn:function(ref){
              var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.modifyByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.modifyDate))])]}},{key:"submitInfo",fn:function(ref){
              var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.submitByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.submitTime))])]}},{key:"reviewInfo",fn:function(ref){
              var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.reviewByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.reviewTime))])]}},{key:"empty",fn:function(ref){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"no-data"},[_vm._v(" "+_vm._s(_vm.$l('INDEX.tips_no_data') || '暂无数据！')+" ")])])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }